import { b2cPolicies, getMSALInstance } from "../config";

export const signUp = () => {
    const myMSALObj = getMSALInstance();
    myMSALObj.loginRedirect(b2cPolicies.authorities.signUpPolicy);
}

